import React, { Suspense, useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import { Toaster } from './components/ui/sonner';
import InstallPWA from './components/InstallPWA';
import './i18n';
import '@/App.css';

// Pages
import LoginPage from './pages/LoginPage';
import DashboardPage from './pages/DashboardPage';
import PoolsPage from './pages/PoolsPage';
import ReadingsPage from './pages/ReadingsPage';
import PublicViewPage from './pages/PublicViewPage';
import UsersPage from './pages/UsersPage';
import QRCodePage from './pages/QRCodePage';
import SubscriptionPage from './pages/SubscriptionPage';
import Layout from './components/Layout';

// Register service worker for PWA
const registerServiceWorker = () => {
  if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
      navigator.serviceWorker.register('/service-worker.js')
        .then((registration) => {
          console.log('AquaPro Logs SW registered:', registration.scope);
        })
        .catch((error) => {
          console.log('AquaPro Logs SW registration failed:', error);
        });
    });
  }
};

const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary"></div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  return children;
};

function AppRoutes() {
  return (
    <Suspense fallback={<div className="min-h-screen flex items-center justify-center">Loading...</div>}>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/public/:poolId" element={<PublicViewPage />} />
        <Route
          path="/*"
          element={
            <ProtectedRoute>
              <Layout>
                <Routes>
                  <Route path="/" element={<DashboardPage />} />
                  <Route path="/pools" element={<PoolsPage />} />
                  <Route path="/pools/:poolId/readings" element={<ReadingsPage />} />
                  <Route path="/pools/:poolId/qr" element={<QRCodePage />} />
                  <Route path="/users" element={<UsersPage />} />
                  <Route path="/subscription" element={<SubscriptionPage />} />
                </Routes>
              </Layout>
            </ProtectedRoute>
          }
        />
      </Routes>
    </Suspense>
  );
}

function App() {
  useEffect(() => {
    registerServiceWorker();
  }, []);

  return (
    <AuthProvider>
      <BrowserRouter>
        <AppRoutes />
        <Toaster position="top-right" />
        <InstallPWA />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;